import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import StepRoutes from "../../../Routes/steps_routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcBusinessman, FcFilmReel, FcSelfServiceKiosk } from "react-icons/fc";
import SimpleButton from "../../../Components/layouts/simple_button";
import { extractDate } from "../../../Components/Functions/date.fun";

const ViewCourceDetails = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/cource/view/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting cource!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  const linkifyText = (text) => {
    if (!text) return "N/A";

    const urlRegex = /(https?:\/\/[^\s]+)/g;

    return text.split(urlRegex).map((part, index) => {
      if (part.match(urlRegex)) {
        return (
          <a key={index} href={part} target="_blank" rel="noopener noreferrer">
            {part}
          </a>
        );
      }
      return part;
    });
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcSelfServiceKiosk className="fs-2 me-1" />
                  Course
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">View Course Topic Details</h2>
            </div>

            <div className="card-body">
              {!data ? (
                <div className="text-center text-muted">No data found</div>
              ) : (
                <>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Course Name</label>
                    <div className="w-100 col">{data?.mediacourseAdd?.courseName || "N/A"}</div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                    Topic Name
                    </label>
                    <div className="w-100 col">
                      {data?.topicName || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Topic Script{" "}
                    </label>
                    <div className="w-100 col">
                      {linkifyText(data?.topicScript) || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                       Editor{" "}
                    </label>
                    <div className="w-100 col">
                      {data?.assignedTo || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Deadline{" "}
                    </label>
                    <div className="w-100 col">
                      {extractDate(data?.taskdedline || "N/A")}
                    </div>
                  </div>


    
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                    Topic first copy nas url{" "}
                    </label>
                    <div className="w-100 col">
                      {linkifyText(data?.courceUrl1) || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                    Topic final nas url{" "}
                    </label>
                    <div className="w-100 col">
                      {linkifyText(data?.courceUrl2 || "N/A")}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                    Published on website {" "}
                    </label>
                    <div className="w-100 col">
                      {data?.markaspublished ? "Yes" : "No" || "N/A"}
                    </div>
                  </div>

                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <SimpleButton
                        buttonText="Edit Course Topic Details"
                        href={`/edit-course/${id}`}
                      />
                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewCourceDetails;
